<div *transloco="let t" class="spread-shadow rounded-xl bg-white p-12 shadow-lg">
    @if (imageSrc) {
        <div class="flex flex-col items-center justify-center">
            <img
                [src]="imageSrc"
                class="h-32 w-32 rounded-full border-4 border-solid border-primary-400 object-cover"
            />
            <button
                (click)="save()"
                class="mt-4 max-w-40 rounded-md border border-primary-400 bg-white px-6 py-1 font-medium text-primary-400"
            >
                {{ t('common.upload') }}
            </button>
        </div>
    } @else {
        <div
            class="flex cursor-pointer flex-col items-center justify-center rounded-md border-4 border-dashed border-primary-200 p-10 hover:bg-primary-50"
            (ngpFileUploadSelected)="onFilesSelected($event)"
            ngpFileUpload
        >
            <i class="fa-solid fa-file-upload text-8xl text-primary-400"></i>
            <p class="mt-8 text-lg font-bold">{{ t('profile.selectOrDragAndDrop') }}</p>
            <p class="mt-2 text-sm text-gray-500">{{ t('profile.suggestedSize') }}: 320 x 320</p>
        </div>
    }
</div>
